import { CmsPersonalDetailsPage } from '../../models/cms/cms-personal-details-page.interface';
import { mockCmsPersonalDetailsForm } from './cms-personal-details-form.mock';

export const mockCmsPersonalDetailsPage: CmsPersonalDetailsPage = {
  ...mockCmsPersonalDetailsForm,
  pageTitle: 'Just a few more details',
};
